module.exports = __webpack_public_path__ + "static/media/contentHome1.02d25112.png";